module.exports = __webpack_public_path__ + "img/サベネア島.d188dfdf.png";